var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "float-right boss-batch-select" },
    _vm._l(_vm.bulkRegisterOptions, function (option, i) {
      return _c(
        "span",
        {
          directives: [
            {
              name: "tooltip",
              rawName: "v-tooltip",
              value: {
                content: _vm.showTooltip(option.limit) ? option.tooltip : "",
              },
              expression:
                "{content: showTooltip(option.limit) ? option.tooltip:''}",
            },
          ],
          key: i,
          attrs: { "data-test": "bulk-button-tooltip-" + option.id },
        },
        [
          _c(
            "button",
            {
              staticClass:
                "boss-button boss-exe-button pega-button pega-mr-5 pega-bulk-button",
              attrs: {
                id: "bulk-button-" + option.id,
                disabled: _vm.isDisabled(option.id, option.limit),
                "data-test": "bulk-button-" + option.id,
              },
              on: {
                click: function ($event) {
                  return _vm.bulkRegister(option.id)
                },
              },
            },
            [
              _c("span", { staticClass: "boss-exe-button-text" }, [
                _vm._v(" " + _vm._s(option.name)),
              ]),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }